import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-bs-datepicker',
    templateUrl: './bs-datepicker.component.html',
    styleUrls: ['./bs-datepicker.component.css']
})
export class BsDatepickerComponent implements OnInit {

    model: NgbDateStruct;
    date: { year: number, month: number };

    constructor(private calendar: NgbCalendar) {
    }

    selectToday() {
        this.model = this.calendar.getToday();
    }

    ngOnInit(): void {
    }

}
